(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NFSearchBehavior = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const MIN_CHARS = 3;
  const DEFAULT_LIMIT = 10;

  function canPredict(rawQuery, minimum = MIN_CHARS) {
    return String(rawQuery || '').trim().length >= minimum;
  }

  function buildUrl(baseUrl, rawQuery, sectionId) {
    const params = new URLSearchParams({
      q: String(rawQuery || '').trim(),
      'resources[type]': 'product',
      'resources[options][fields]': 'title,vendor,product_type,variants.title',
      section_id: sectionId,
    });

    return `${baseUrl}?${params.toString()}`;
  }

  // Caixa baixa e sem acento, para "jacaranda" achar "JACARANDÁ" e vice-versa.
  function normalizeTerm(value) {
    return String(value == null ? '' : value)
      .trim()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  }

  // A busca da Shopify indexa por PREFIXO de palavra: "cach" acha "CACHIMBO",
  // mas "chimb" nao acha nada. Aqui a comparacao e' por trecho em qualquer
  // posicao, que e' o que falta na nativa.
  function matchesTerm(text, query) {
    const haystack = normalizeTerm(text);
    const needle = normalizeTerm(query);
    if (!haystack || !needle) return false;
    return haystack.includes(needle);
  }

  // 0 = o texto comeca com o termo; 1 = uma palavra comeca com o termo;
  // 2 = o termo esta no meio de uma palavra. Menor vem primeiro.
  function rankOf(text, needle) {
    const haystack = normalizeTerm(text);
    const position = haystack.indexOf(needle);
    if (position === -1) return -1;
    if (position === 0) return 0;
    return /[\s\-–—/(,.]/.test(haystack[position - 1]) ? 1 : 2;
  }

  function filterIndex(index, query, options) {
    const limit = (options && options.limit) || DEFAULT_LIMIT;
    if (!Array.isArray(index) || !canPredict(query)) return [];

    const needle = normalizeTerm(query);
    if (!needle) return [];

    const scored = [];
    index.forEach((item) => {
      if (!item) return;
      let best = -1;
      [item.title, item.vendor, item.type].forEach((field) => {
        if (!field) return;
        const rank = rankOf(field, needle);
        if (rank !== -1 && (best === -1 || rank < best)) best = rank;
      });
      if (best !== -1) scored.push({ item, rank: best });
    });

    // Array.prototype.sort e' estavel: empates preservam a ordem do catalogo.
    scored.sort((a, b) => a.rank - b.rank);
    return scored.slice(0, limit).map((entry) => entry.item);
  }

  // Resultados da busca nativa primeiro (relevancia do servidor, cobre tag e
  // descricao); os achados por trecho entram depois, sem repetir produto.
  function mergeResults(nativeResults, partialResults, limit = DEFAULT_LIMIT) {
    const out = [];
    const seen = new Set();

    [nativeResults, partialResults].forEach((list) => {
      if (!Array.isArray(list)) return;
      list.forEach((item) => {
        if (!item || out.length >= limit) return;
        const key = item.url || item.handle || item.id;
        if (key) {
          if (seen.has(key)) return;
          seen.add(key);
        }
        out.push(item);
      });
    });

    return out;
  }

  // Indice enxuto servido pelo proprio tema (templates/collection.nf-search-index.liquid).
  // O /products.json publico traz 259 KB para os mesmos 57 produtos.
  function buildIndexUrl(rootUrl) {
    const root = String(rootUrl || '').replace(/\/$/, '');
    return `${root}/collections/all?view=nf-search-index`;
  }

  return {
    canPredict,
    buildUrl,
    normalizeTerm,
    matchesTerm,
    filterIndex,
    mergeResults,
    buildIndexUrl,
    MIN_CHARS,
  };
});
